<template>
  <v-container>
    <div>
      <v-layout wrap>
        <v-flex xs6>
          <h2 class="title grey--text mt-2">Working hours</h2>
        </v-flex>
        <v-flex xs6 class="text-xs-right">
          <v-btn v-if="!isEdit" icon outline color="primary" @click="isEdit = true">
            <v-icon>edit</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-card class="mt-2">
        <div class="pa-2 hidden-xs-only">
          <v-layout wrap>
            <v-flex xs4 class="text-xs-center strong">{{ $t('Date_1') }}</v-flex>
            <v-flex xs4 class="text-xs-center strong">{{ $t('Open at') }}</v-flex>
            <v-flex xs4 class="text-xs-center strong">{{ $t('Close at') }}</v-flex>
          </v-layout>
        </div>
        <v-divider></v-divider>
        <template v-for="(time, key) in timetable">
          <open-time-bot-item
            :key="key"
            v-model="timetable[key]"
            :name="key"
            :is-edit="isEdit"
          ></open-time-bot-item>
        </template>
      </v-card>
      <div v-if="isEdit" class="text-xs-center mt-4">
        <v-btn color="grey" outline @click="onCancelTimeTable">{{ $t('cancel') }}</v-btn>
        <v-btn :loading="loading" depressed color="primary" @click="onSaveTimeTable">{{
          $t('Save')
        }}</v-btn>
      </div>
    </div>
  </v-container>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import OpenTimeBotItem from './OpenTimeBotItem'
export default {
  components: {
    OpenTimeBotItem
  },
  data() {
    return {
      isEdit: false,
      loading: false,
      timetable: {
        Monday: { status: true, openat: null, closeat: null },
        Tuesday: { status: true, openat: null, closeat: null },
        Wednesday: { status: true, openat: null, closeat: null },
        Thursday: { status: true, openat: null, closeat: null },
        Friday: { status: true, openat: null, closeat: null },
        Saturday: { status: true, openat: null, closeat: null },
        Sunday: { status: true, openat: null, closeat: null }
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      setting: 'setting'
    })
  },
  async mounted() {
    await this.$store.dispatch('loadSetting')
    if (this.setting && this.setting.hasOwnProperty('working_hours')) {
      this.timetable = JSON.parse(this.setting['working_hours'].contentvalue)
    } else {
      this.timetable = {
        Monday: { status: true, openat: null, closeat: null },
        Tuesday: { status: true, openat: null, closeat: null },
        Wednesday: { status: true, openat: null, closeat: null },
        Thursday: { status: true, openat: null, closeat: null },
        Friday: { status: true, openat: null, closeat: null },
        Saturday: { status: true, openat: null, closeat: null },
        Sunday: { status: true, openat: null, closeat: null }
      }
    }
    this.cached_timetable = JSON.stringify(this.timetable)
  },
  methods: {
    onCancelTimeTable: function () {
      var vm = this
      vm.timetable = JSON.parse(vm.cached_timetable)
      vm.isEdit = false
    },
    onSaveTimeTable: function () {
      var vm = this
      return new Promise(async (resolve, reject) => {
        vm.$validator.validateAll().then(async (result) => {
          if (!result) {
            // do stuff if not valid.
            vm.goToErrorInput()
            reject()
            return false
          }

          vm.loading = true
          var allsave = []
          vm.saveApi(this.selectedBot.pageid)
          await Promise.all(allsave)
          vm.loading = false
          vm.cached_timetable = JSON.stringify(vm.timetable)
          vm.isEdit = false
        })
      })
    },
    saveApi(pageid) {
      var vm = this
      return new Promise((resolve) => {
        var data = {
          workingHours: vm.timetable,
          pageid
        }
        api.commonSetWorkingHours(data, function (error, response) {
          if (error) {
            reject(error)
          }

          resolve()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/generali/WorkingHour.vue